export class ThrottleAmounts {
    constructor(json?: any) {
        if (json) {
            this.timed = json.timed as number | undefined;
            this.fiveMinute = json.fivemin as number | undefined;
            this.hour = json.hour as number | undefined;
            this.day = json.day as number | undefined;
            this.expiryMilliseconds = json.expiry as number | undefined;
        }
    }

    toJSON() {
        return {
            timed: this.timed,
            fivemin: this.fiveMinute,
            hour: this.hour,
            day: this.day,
            expiry: this.expiryMilliseconds
        };
    }

    timed: number | undefined;
    fiveMinute: number | undefined;
    hour: number | undefined;
    day: number | undefined;
    expiryMilliseconds: number | undefined;
}